import { Button } from "../ui/Button";
import { KioskPanel } from "./KioskPanel";

const points = [
  ["01", "Secure facilities"],
  ["02", "Data centres"],
  ["03", "Multi-site operations"],
];

export function HeroSection() {
  return (
    <section className="relative overflow-hidden">
      <div className="pointer-events-none absolute -right-24 top-0 h-80 w-80 rounded-full bg-sky-100 blur-3xl" aria-hidden="true" />
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 py-16 lg:grid-cols-[1.05fr_0.95fr] lg:py-20">
        <div>
          <p className="text-sm font-bold tracking-[0.18em] text-brand-blue">ENTERPRISE VISITOR MANAGEMENT</p>
          <h1 className="mt-4 max-w-xl text-5xl font-extrabold leading-[1.02] text-brand-ink sm:text-6xl">
            Secure people.<br />Smarter access.<br /><span className="text-brand-blue">Greater control.</span>
          </h1>
          <p className="mt-6 max-w-lg text-lg leading-8 text-slate-600">Know who is entering, why they are entering, who approved them, and when access ends. Built for data centres and other high-security facilities across Africa.</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href="#demo" className="inline-flex items-center justify-center rounded-full bg-brand-orange px-5 py-3 text-base font-semibold text-white hover:bg-[#c4631d]">Request a demo</a>
            <Button variant="secondary" className="rounded-full" onClick={() => document.getElementById("overview")?.scrollIntoView({ behavior: "smooth" })}>Watch overview</Button>
          </div>
          <ul className="mt-10 flex flex-wrap gap-x-6 gap-y-3">
            {points.map(([index, label]) => (
              <li key={label} className="flex items-center gap-2 text-sm font-semibold text-slate-700">
                <span className="text-xs font-bold text-brand-blue">{index}</span>
                {label}
              </li>
            ))}
          </ul>
        </div>
        <div className="relative mx-auto flex min-h-[520px] w-full max-w-lg items-end justify-center">
          <div className="absolute inset-x-8 bottom-8 top-6 rounded-[32px] bg-[#0B1C33]" aria-hidden="true" />
          <div className="absolute inset-x-16 bottom-0 h-16 rounded-full bg-slate-900/10 blur-md" aria-hidden="true" />
          <div className="relative z-10 mb-14">
            <KioskPanel />
          </div>
          <div className="absolute left-2 top-10 z-20 hidden rounded-xl border border-white/60 bg-white/80 px-4 py-3 shadow-lg backdrop-blur-md sm:block">
            <p className="text-sm font-bold tracking-wide text-slate-500">ON SITE NOW</p>
            <p className="mt-1 text-2xl font-extrabold text-brand-ink">12</p>
            <p className="text-xs text-slate-500">Visitors checked in</p>
          </div>
          <div className="absolute bottom-16 right-2 z-20 hidden rounded-xl border border-white/60 bg-white/80 px-4 py-3 shadow-lg backdrop-blur-md sm:block">
            <p className="text-sm font-bold tracking-wide text-slate-500">NEXT ARRIVAL</p>
            <p className="mt-1 text-sm font-bold text-brand-ink">John Visitor</p>
            <p className="text-xs text-slate-500">Expected · Main Data Centre</p>
          </div>
        </div>
      </div>
    </section>
  );
}
